import { render } from "./Root.vue?vue&type=template&id=d309f5ce&lang=html"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import "./Root.vue?vue&type=style&index=0&id=d309f5ce&lang=postcss"
script.render = render

export default script